'use client';

import { useState } from 'react';
import Icon from '@/components/ui/AppIcon';

const reviews = [
  {
    name: 'Fabian Voss',
    source: 'Google Reviews',
    rating: 5,
    text: 'È stato fantastico!! La scheda (Audi e-tron) era praticamente nuova. La guida è arrivata e ha spiegato tutto perfettamente. Lo rifarei volentieri!',
  },
  {
    name: 'Jack Smith',
    source: 'Google Reviews',
    rating: 5,
    text: "Esperienza molto divertente, le tavole sono di ottima qualità e l'insegnamento è molto amichevole e rilassato. Ottimo rapporto qualità prezzo e nel complesso un'esperienza memorabile, altamente consigliata.",
  },
  {
    name: 'Kriss Cool',
    source: 'Google Reviews',
    rating: 5,
    text: "Esperienza fantastica! L\'attrezzatura è davvero di prim\'ordine e imparare sul Lago Maggiore è un piacere. Al mattino il lago è molto piatto e poco affollato. Grazie mille!",
  },
  {
    name: 'Vincent FL',
    source: 'Google Reviews',
    rating: 5,
    text: "Mi sono divertito molto. L\'insegnante parla inglese ed è molto calmo e istruttivo.",
  },
  {
    name: 'Mischa Guarda',
    source: 'Google Reviews',
    rating: 5,
    text: 'Molto amichevole, competente e cortese.',
  },
];

function GoogleIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
      <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
      <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
      <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
    </svg>
  );
}

export default function TestimonialsSection({ lang = 'it' }: { lang?: 'it' | 'en' }) {
  const [, setActive] = useState(0);

  return (
    <section style={{ padding: 'var(--section-pad) 0', background: '#122940' }}>
      <div className="container-main">
        <div style={{ textAlign: 'center', marginBottom: '40px' }}>
          <div className="badge badge-gold" style={{ marginBottom: '16px', gap: '6px' }}>
            <Icon name="StarIcon" size={12} variant="solid" />
            {lang === 'it' ? 'Valutazione media 5.0 su Google' : 'Average rating 5.0 on Google'}
          </div>
          {/* Aggregate rating display */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '10px', marginBottom: '16px' }}>
            <span style={{ fontFamily: 'Fraunces, Georgia, serif', fontSize: 'clamp(2rem, 5vw, 3rem)', fontWeight: 700, color: '#F0F7FF', lineHeight: 1 }}>5.0</span>
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '4px' }}>
              <div style={{ display: 'flex', gap: '3px' }}>
                {[...Array(5)].map((_, i) => (
                  <Icon key={i} name="StarIcon" size={16} variant="solid" style={{ color: '#E8A94D' }} />
                ))}
              </div>
              <span style={{ fontSize: '13px', color: 'rgba(240,247,255,0.45)', letterSpacing: '0.04em' }}>
                {lang === 'it' ? '5 recensioni' : '5 reviews'}
              </span>
            </div>
          </div>
          <h2
            style={{
              fontFamily: 'Fraunces, Georgia, serif',
              fontSize: 'clamp(1.8rem, 5vw, 3rem)',
              fontWeight: 700,
              letterSpacing: '-0.02em',
            }}
          >
            {lang === 'it' ? 'Cosa dicono i nostri ospiti' : 'What our guests say'}
          </h2>
        </div>

        {/* Review cards */}
        <div
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
          style={{
            gap: '16px',
            marginBottom: '32px',
          }}
        >
          {reviews.map((r) => (
            <div key={r.name} className="testimonial-card">
              {/* Stars */}
              <div style={{ display: 'flex', gap: '3px', marginBottom: '12px' }}>
                {[...Array(r.rating)].map((_, si) => (
                  <Icon key={si} name="StarIcon" size={14} variant="solid" style={{ color: '#E8A94D' }} />
                ))}
              </div>
              <p
                style={{
                  fontSize: '14px',
                  color: 'rgba(240,247,255,0.75)',
                  lineHeight: 1.7,
                  marginBottom: '16px',
                  fontStyle: 'italic',
                }}
              >
                &ldquo;{r.text}&rdquo;
              </p>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <div>
                  <p style={{ fontSize: '14px', fontWeight: 700 }}>{r.name}</p>
                  <p style={{ fontSize: '12px', color: 'rgba(240,247,255,0.4)' }}>{r.source}</p>
                </div>
                <div className="badge badge-cyan" style={{ fontSize: '10px', padding: '3px 8px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                  <GoogleIcon />
                  Google
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Google CTA */}
        <div style={{ textAlign: 'center' }}>
          <a
            href="https://www.google.com/maps/search/E-Foil+Experience+Lago+Maggiore"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-secondary"
            style={{ fontSize: '14px', display: 'inline-flex', alignItems: 'center', gap: '8px' }}
          >
            <GoogleIcon />
            {lang === 'it' ? 'Vedi tutte le recensioni su Google' : 'See all reviews on Google'}
          </a>
        </div>
      </div>
    </section>
  );
}
